/** The staff app (/staff and below) has its own toaster in its layout. */
export function rootToasterHidden(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return pathname === '/staff' || pathname.startsWith('/staff/');
}
